export const ShipmentStatus: { [key: string]: string } = {
    default: 'Не е заявена към куриер',
    pending: 'Подготвя се',
    request_pickup: 'Заявена към куриер',
    dispatched: 'Предадена на куриер',
    in_transit: 'В доставка',
    out_for_delivery: 'На разнос',
    delivered: 'Доставена',
    undelivered: 'Недоставена',
    returned: 'Върната',
    cancelled: 'Отказана'
};
